module.exports = __webpack_public_path__ + "img/dg-browse-vehicles-red.0de381cb.png";